import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import commonLabels from "../../../common/labels/common_en.json";
import html2pdf from "html2pdf.js";
import label from "../../labels/interviewProcess_en.json";
import {
  getMainsAdvertisements,
  getYearList,
} from "../../../common/actions/commonActions";
import { getMeritListReport, getExamslistByAdvertisementId } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getCriteriaCheckingByAdvertisementId } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import moment from "moment";

const CriteriaForChecking = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    setReloadItem(!reloadItem);
    if (criteriaForCheckingList.qualifiedCandidates) {
      criteriaForCheckingList.qualifiedCandidates.length = 0;
    }
  }, []);
  const dispatch = useDispatch();
  const [selectedExam, setSelectedExam] = useState("");
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [selectedPostCriteria, setSelectedPostCriteria] = useState("");

  const session = JSON.parse(sessionStorage.getItem("session"));
  let { examList, advertisementList, postcriterialisting, criteriaForCheckingList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getMainsAdvertisements(selectedValue));
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }

    setSaveButtonFlag(true);
    //  dispatch({
    //   type:SET_QUALIFYING_CANDIDATES_LIST,
    //   payload:[]
    //  })
    setReloadItem(!reloadItem);
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvert(selectedValue);
    setSelectedExam("");
    setSelectedPostCriteria("")
    examList.length = 0;
   
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };
  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedPostCriteria("")
    setSelectedExam(selectedValue);
   
    ele && dispatch(getCriteriaCheckingByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };
  const onPostCriteriaChange = (ele) => {
    setSelectedPostCriteria(ele);

    // setSaveDataButtonFlag(false);
    // setPrintFlag(true);
    // setConfirmClicked(false);
    // dispatch({
    //   type: GET_STATISTICALDATA,
    //   payload: {},
    // });
    ele && dispatch(getMeritListReport(selectedAdvert, selectedExam, ele));
    setReloadItem(!reloadItem);
  };

  const printQualifyingListPDF = () => {
    genPdf();
    //dispatch(printQualifyingCandidatesList(selectedExam));
  };

  // const getPostCriteriaName = (id) =>{
  // let postcriteraname =
  //         postcriterialisting &&
  //         postcriterialisting.length > 0 &&
  //         postcriterialisting.find((post) => post.id === selectedPostCriteria);

  // return postcriteraname ? postcriteraname.name : ''
  // }


  const genPdf = () => {
    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + criteriaForCheckingList.examName + '</h5><h5>' + commonLabels.Criteria_For_Checking_REPORT + '</h5></div>';
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;


    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: 'Criteria_For_Checking_Report_.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compressPDF: true },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');
          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = criteriaForCheckingList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`Criteria_For_Checking_Report_${selectedExam}.pdf`);

      });
  };

  return (
    <div className="">
      <h5> {label.CriteriaForChecking} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                        // <option key={index} value={element.id}>
                        //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                        // </option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getMainsAdvertisement &&
                      getMainsAdvertisement.length > 0 &&
                      getMainsAdvertisement
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className="form-group col-md-4">
                  <label className="float-left">
                    {commonLabels.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                {/* <div className="form-group col-md-3">
                        <label className="float-left">
                          {commonLabels.PostCriteria}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedPostCriteria"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onPostCriteriaChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {postcriterialisting &&
                            postcriterialisting.length > 0 &&
                            postcriterialisting
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedPostCriteria.type", errors) ===
                          "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>*/}

              </div>
            </div>
          </form>
        </div>
      </div>
      {criteriaForCheckingList && criteriaForCheckingList.advertisementNo && criteriaForCheckingList.qualifiedCandidates.length > 0 && (
        <>
          {(session.roleName == "superadmin" ||
            session.roleName == "desk officer") && (
              <div className="row ">
                <div className="col-md-12">
                  {" "}
                  <button
                    type="button"
                    className="btn btn-primary mb-2 float-right"
                    onClick={() => {
                      printQualifyingListPDF();
                    }}
                  >
                    {commonLabels.BUTTON_PRINT}
                  </button>
                </div>
              </div>
            )}
          <div ref={pdfRef} id="">
            <div className="row ">
              <div className="table-responsive answerKeyTable p-3  col-md-12">
                <table className="table text-left">
                  <thead className="">
                    <tr >
                      <th className="text-center" scope="col w-5">{label.RollNo}</th>
                      <th className="text-center" scope="col w-30">{label.Int_No}</th>
                      <th className="text-left" scope="col w-5">{label.CandidateName}</th>
                      <th className="text-center" scope="col w-5">{label.Gender}</th>
                      <th className="text-center" scope="col w-5">{label.Applied_Category}</th>
                      <th className="text-center" scope="col w-5">{label.NCL}</th>
                      <th className="text-center" scope="col w-5">{label.OtherReservation}</th>
                      <th className="text-center" scope="col w-5">{label.DOB}</th>
                      <th scope="col w-5">{label.HighEDu}</th>
                      <th scope="col w-5">{label.ElgOrNot}</th>
                      {/* <th className="p-3" scope="col w-5">{label.status}</th> */}
                    </tr>
                    {/* <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th scope="col w-5">{label.Wrt}<br/>{label.Tot}</th>
                        <th scope="col w-5">{label.Int}</th>
                        <th scope="col w-5">{label.Total}</th>
                        <th></th>

                      </tr> */}
                  </thead>
                  <tbody className="tbody-style">
                    {criteriaForCheckingList &&
                      criteriaForCheckingList.qualifiedCandidates &&
                      criteriaForCheckingList.qualifiedCandidates.length > 0 &&
                      criteriaForCheckingList.qualifiedCandidates.map(
                        (ele, ind) => {
                          return (
                            <tr key={ind}>
                              {/* <td className="text-left">{ind + 1}</td> */}
                              <td className="text-center" >{ele.rollNo}</td>
                              <td className="text-center" >{ele.interviewNo}</td>
                              <td className="text-left" >{ele.candidateName}</td>
                              <td className="text-center" >{ele.gender}</td>
                              <td className="text-center" >{ele.category}</td>
                              <td className="text-center" >{ele.ncl}</td>
                              <td className="text-center" >{ele.otherReservation}</td>
                              <td className="text-center" >{ele.dob
                                ? moment(ele.dob).format("DD/MM/YYYY")
                                : ""}</td>
                              <td >{ele.higherEduQual}</td>
                              <td ></td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CriteriaForChecking